import { render, staticRenderFns } from "./calendar-event-expanded-card.vue?vue&type=template&id=3e0d08c7&scoped=true"
import script from "./calendar-event-expanded-card.vue?vue&type=script&lang=js"
export * from "./calendar-event-expanded-card.vue?vue&type=script&lang=js"
import style0 from "./calendar-event-expanded-card.vue?vue&type=style&index=0&id=3e0d08c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0d08c7",
  null
  
)

export default component.exports